<template>
	<div class="flex flex-col justify-start">
		<div class="min-w-full flex-grow pb-36 overflow-x-auto bg-gray-100">
			<!-- overflow-hidden -->
			<div
				class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mb-4"
			>
				<div class="flex text-gray-400 my-4">
					<ui-icon name="fa-handshake" class="text-4xl mr-4" />
					<h3 class="text-2xl font-medium">
						{{ __("Successful contract conclusions") }}
					</h3>
				</div>

				<table class="min-w-full divide-y divide-gray-200 bg-white">
					<thead class="bg-gray-50">
						<tr>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Quantity") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Goods/Harvest") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Fulfilment Date") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Location") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Ihr Preis") }}
							</th>
							<th
								scope="col"
								class="pl-2 pr-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
							></th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200">
						<auction-result-bid
							v-for="(bid, idx) in results.WON"
							:key="'WON_' + idx"
							:bid="bid"
							:idx="idx"
							:type="'win'"
						/>
					</tbody>
				</table>
			</div>

			<div
				class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mb-4"
			>
				<div class="flex text-gray-400 my-4">
					<ui-icon name="fa-messages" class="text-4xl mr-4" />
					<h3 class="text-2xl font-medium">
						{{ __("Negotiations started as highest bidder") }}
					</h3>
				</div>

				<table class="min-w-full divide-y divide-gray-200 bg-white">
					<thead class="bg-gray-50">
						<tr>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Quantity") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Goods/Harvest") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Fulfilment Date") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Location") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Ihr Preis") }}
							</th>
							<th
								scope="col"
								class="pl-2 pr-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider"
							></th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200">
						<auction-result-bid
							v-for="(bid, idx) in results.HIGHEST_BID"
							:key="'HIGHEST_BID_' + idx"
							:bid="bid"
							:idx="idx"
							:type="'thread'"
						/>
					</tbody>
				</table>
			</div>

			<div
				class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg mb-4"
			>
				<div class="flex text-gray-400 my-4">
					<ui-icon name="fa-circle-x" class="text-4xl mr-4" />
					<h3 class="text-2xl font-medium">{{ __("No highest bidder") }}</h3>
				</div>

				<table class="min-w-full divide-y divide-gray-200 bg-white">
					<thead class="bg-gray-50">
						<tr>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Quantity") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Goods/Harvest") }}
							</th>
							<th
								scope="col"
								class="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Fulfilment Date") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Location") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Ihr Preis") }}
							</th>
							<th
								scope="col"
								class="px-2 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
							>
								{{ __("Höchster Preis") }}
							</th>
						</tr>
					</thead>
					<tbody class="divide-y divide-gray-200">
						<auction-result-bid
							v-for="(bid, idx) in results.LOST"
							:key="'LOST_' + idx"
							:bid="bid"
							:idx="idx"
							:type="'loss'"
						/>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		auction: {
			type: Object,
			required: true,
		},
		results: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			acl: this.$inertia.page.props.acl,
		};
	},
	methods: {},
	computed: {},
};
</script>
